// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInQuarters/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInQuarters = convertToFP(fn, 2);
export default differenceInQuarters;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInQuarters/index.js
// module id = 841
// module chunks = 0